import { render, staticRenderFns } from "./IOSGuide.vue?vue&type=template&id=207c4f9b&scoped=true"
import script from "./IOSGuide.vue?vue&type=script&lang=js"
export * from "./IOSGuide.vue?vue&type=script&lang=js"
import style0 from "./IOSGuide.vue?vue&type=style&index=0&id=207c4f9b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "207c4f9b",
  null
  
)

export default component.exports